import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HalfAndHalf from './icon-half-and-half.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HalfAndHalf {...validProps} />;
}
SvgComponent.iconName = 'half-and-half';

export const HalfAndHalfIcon = svgIconWrapper(SvgComponent);
